import styles from "../../assets/css/pane.module.scss";
import { goToAbound } from "../../libs/utils";
// import AboundLogo from "..//../assets/img/aboundlogo.svg";
// import LeftPaneImage from "..//../assets/img/leftpaneimg.svg";

const RemittanceHomeLeftPane = () => {
  return (
    <div className={styles.leftPane}>
      <div className={styles.logoContainer} onClick={goToAbound}>
        <img
          className={styles.logo}
          src="https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/Website%2BRemittance/aboundlogo.svg"
          alt="AboundLogo"
        />
      </div>
      <div className={styles.homeMainContainer}>
        <img
          className={styles.leftpaneimg}
          src="https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/Website%2BRemittance/leftpaneimg.svg"
          alt="LeftPaneImage"
        />
      </div>
    </div>
  );
};
export default RemittanceHomeLeftPane;
